(function () {
  if (window.haCartConfirmationReady) return;
  window.haCartConfirmationReady = true;

  function updateBasketCount(count) {
    document.querySelectorAll("[data-ha-basket-count]").forEach(function (node) {
      node.textContent = String(count);
    });
  }

  function ensureDialog() {
    var existing = document.querySelector("[data-ha-cart-confirmation-dialog]");
    if (existing) return existing;

    var dialog = document.createElement("dialog");
    dialog.className = "ha-cart-confirmation";
    dialog.setAttribute("data-ha-cart-confirmation-dialog", "");
    dialog.innerHTML = [
      '<div class="ha-cart-confirmation__content">',
      '<p class="ha-cart-confirmation__kicker">Added to your basket</p>',
      '<h2>Your part is ready when you are.</h2>',
      '<p data-ha-cart-confirmation-message>Choose whether to review your basket or carry on shopping from this page.</p>',
      '<div class="ha-cart-confirmation__actions">',
      '<a class="btn btn--amber" href="/cart">View basket</a>',
      '<button class="btn ha-cart-confirmation__continue" type="button" data-ha-cart-confirmation-close>Continue shopping</button>',
      '</div>',
      '</div>'
    ].join("");
    document.body.appendChild(dialog);

    dialog.querySelector("[data-ha-cart-confirmation-close]").addEventListener("click", function () {
      dialog.close();
    });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) dialog.close();
    });
    return dialog;
  }

  async function addToCart(form) {
    var submit = form.querySelector('[type="submit"]');
    var originalLabel = submit ? submit.textContent : "";
    if (submit) {
      submit.disabled = true;
      submit.textContent = "Adding...";
    }

    try {
      var response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
        credentials: "same-origin"
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || "This product could not be added to your basket.");

      var cartResponse = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "cart.js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      if (cartResponse.ok) {
        var cart = await cartResponse.json();
        updateBasketCount(cart.item_count || 0);
      }

      var dialog = ensureDialog();
      var message = dialog.querySelector("[data-ha-cart-confirmation-message]");
      if (message) {
        message.textContent = (result.product_title || "Your product") + " has been added. Review your basket or continue shopping from this page.";
      }
      if (typeof dialog.showModal === "function") {
        dialog.showModal();
      } else {
        window.location.assign("/cart");
      }
    } catch (error) {
      var dialog = ensureDialog();
      var message = dialog.querySelector("[data-ha-cart-confirmation-message]");
      if (message) message.textContent = error.message || "This product could not be added to your basket.";
      if (typeof dialog.showModal === "function") dialog.showModal();
    } finally {
      if (submit) {
        submit.disabled = false;
        submit.textContent = originalLabel;
      }
    }
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target.closest("form[data-ha-cart-confirmation], form.home-product-form");
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(form);
    },
    true
  );
})();
